export const SET_USERINFO = "SET_USERINFO";
